module.exports = __webpack_public_path__ + "assets/img/b23f-mg.svg";